(function() {
    'use strict';
    
a3_cabin_reports.factory('SyncLogFactory', SyncLogFactory);
  
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SyncLogFactory
    * @description 
    *  Add, update or delete synchronization log
    * @ngInject
    */ 
function SyncLogFactory($log, GenericService) {

        /**
        * Initialize the Sync Log
        * @memberof SyncLogFactory
        */
        function SyncLog() {
			var self = this;
			this.userAimsId = null;
			this.date = null;
			this.version = null;
			this.lastShow = null;
			this.isUpdated = false;
			this.lastScheduleDate = null;
			this.forceSync = false;
			//showing the sync dialog
			this.canShowSync = function() {
				var can = false;
				if (this.lastShow == null)
					can = true;
				else if ((new Date()).add(-10).minutes().toUTC().isAfter(new Date(this.lastShow).toUTC())) {
					can = true;
				}
				return can;
			}
		}

		var objType = 'syncLog';
		var objCallback = SyncLog; 
			
		var service = {
			getSyncLog : getSyncLog,
			setSyncLog : setSyncLog,
			updateSyncVersion : updateSyncVersion,
			setLastShow : setLastShow,
			clearSyncLog : clearSyncLog,
            getLastScheduleDate : getLastScheduleDate,
			setLastScheduleDate : setLastScheduleDate,
			forceSync : forceSync
		}
	
        /**
         * Get Sync Log
         * @memberof SyncLogFactory
         * @return {object} syncLog  
         */
		function getSyncLog() {
			return GenericService.getOne(objType,objCallback);
		}

        /**
         * Set Sync Log
         * @memberof SyncLogFactory
         * @param {string} userAimsId 
         * @param {string} version 
         * @param {string} lastScheduleDate  
         */
		function setSyncLog(userAimsId, version, lastScheduleDate) {
			var newLog = new SyncLog();
			newLog.userAimsId = userAimsId;
			newLog.date = new Date();
			newLog.version = version;
			newLog.lastShow = new Date();
			newLog.isUpdated = false;
			newLog.forceSync = false;
            newLog.lastScheduleDate = new Date(lastScheduleDate).getTime();
			GenericService.saveOne(newLog,objType,objCallback);
		}

         /**
         * Update Sync Log version
         * @memberof SyncLogFactory
         * @param {string} version 
         */
		function updateSyncVersion(version) {

			var syncLog = SyncLog.getSyncLog();

			syncLog.version = version;
			syncLog.isUpdated = true;


			GenericService.saveOne(syncLog,objType,objCallback);
		}

        /**
         * Set last show of molal
         * @memberof SyncLogFactory
         */
		function setLastShow() {
			var log = getSyncLog();
			if (log == null) log = new SyncLog();
			log.lastShow = new Date();

			GenericService.saveOne(log,objType,objCallback);
		}
			
         /**
         * Clear Sync Log
         * @memberof SyncLogFactory
         */
		function clearSyncLog() {
			GenericService.removeAll(objType,objCallback);
		}
      
        /**
         * Get Last Schedule Date
         * @memberof SyncLogFactory
         * @return {string} date 
         */
        function getLastScheduleDate() {
            var syncLog = getSyncLog();
            if (syncLog == null){
                return null;
            }else{   
			 return syncLog.lastScheduleDate;
            }
		}

        /**
         * Set Last Schedule Date
         * @memberof SyncLogFactory
         * @param {string} date 
         */
		function setLastScheduleDate(date) {
            var log = getSyncLog();
			if (log == null) log = new SyncLog();
			log.lastScheduleDate = date;

			GenericService.saveOne(log,objType,objCallback);
		}

		/**
		 * Forces Sync Modal to appear
		 * @memberof SyncLogFactory
		 */
		function forceSync(){
			var syncLog = getSyncLog();
			syncLog.forceSync = true;
			GenericService.saveOne(syncLog,objType,objCallback);
		}

		return service;
	}

})();